import React, { useState } from "react";
import styled from "styled-components";
import { useHistory } from "react-router-dom";
import { InputOutput } from "../components/GuiElements";

const NewPlayer = ({ settings, savedPlayers, setSavedPlayers }) => {
  const history = useHistory();
  const [newPlayer, setNewPlayer] = useState("");

  return (
    <Card
      style={{
        background: !settings.darkmode
          ? "var(--main-dark-color)"
          : "var(--main-light-color)",
      }}
    >
      <header>
        <h2 style={{ color: !settings.darkmode ? "#fff" : "#000" }}>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="51.503"
            height="51.5"
            viewBox="0 0 51.503 51.5"
          >
            <path
              fill={!settings.darkmode ? "#fff" : "#000"}
              id="Pfad_4"
              data-name="Pfad 4"
              d="M43.5,7.781A25.24,25.24,0,1,0,7.77,43.428c.014.014.02.036.034.049.146.141.3.26.453.395.406.361.811.734,1.239,1.082.229.18.467.361.7.526.4.3.808.6,1.23.88.287.18.582.361.876.541.389.234.777.471,1.179.685.341.18.689.335,1.035.5.379.18.752.361,1.14.523s.777.289,1.17.429.732.27,1.109.386c.426.128.862.227,1.295.334.361.088.71.189,1.082.261.5.1,1,.162,1.507.231.312.043.617.1.932.135.826.081,1.659.126,2.5.126s1.673-.045,2.5-.126c.316-.031.62-.092.932-.135.5-.069,1.01-.132,1.507-.231.361-.072.721-.18,1.082-.261.433-.106.869-.206,1.295-.334.377-.115.741-.256,1.109-.386s.786-.27,1.17-.429.761-.344,1.14-.523c.346-.164.694-.319,1.035-.5.4-.215.79-.451,1.179-.685.294-.18.59-.344.876-.541.422-.278.826-.579,1.23-.88.234-.18.472-.343.7-.526.427-.343.833-.707,1.239-1.082.148-.135.306-.254.453-.395.014-.013.02-.034.034-.049A25.212,25.212,0,0,0,43.5,7.781ZM39.443,41.54c-.328.289-.667.563-1.01.828-.2.155-.4.308-.611.456-.326.236-.658.46-1,.674-.245.157-.5.308-.748.456q-.476.271-.966.541c-.289.148-.582.287-.878.424s-.622.283-.941.411-.658.249-.992.361c-.3.1-.609.213-.918.3-.361.108-.737.2-1.111.287-.292.068-.581.146-.876.2-.427.083-.864.141-1.3.2-.249.032-.5.078-.747.1-.692.067-1.394.106-2.1.106s-1.41-.04-2.1-.106c-.251-.025-.5-.07-.747-.1-.438-.059-.874-.117-1.3-.2-.3-.058-.584-.135-.876-.2-.373-.09-.745-.18-1.111-.287-.308-.092-.613-.2-.918-.3-.334-.115-.667-.233-.992-.361s-.631-.269-.941-.411-.59-.276-.878-.424c-.326-.169-.649-.348-.966-.541-.252-.148-.5-.3-.748-.456-.337-.215-.669-.438-1-.674-.207-.148-.409-.3-.611-.456-.343-.265-.682-.541-1.01-.828-.079-.059-.151-.135-.229-.2a14.466,14.466,0,0,1,9.832-13.514,10.691,10.691,0,0,0,9.185,0,14.466,14.466,0,0,1,9.832,13.514C39.592,41.405,39.52,41.474,39.443,41.54ZM18.956,14.467a7.212,7.212,0,1,1,9.821,9.821.038.038,0,0,0-.031.011,7.639,7.639,0,0,1-1.507.638c-.094.027-.18.063-.279.087-.18.047-.37.079-.555.112a7.3,7.3,0,0,1-1.058.106h-.206a7.3,7.3,0,0,1-1.058-.106c-.18-.032-.371-.065-.555-.112-.1-.023-.18-.059-.279-.087A7.633,7.633,0,0,1,21.74,24.3l-.032-.011A7.212,7.212,0,0,1,18.956,14.467ZM42.867,37.761h0a18.12,18.12,0,0,0-9.654-12.428,10.818,10.818,0,1,0-15.939,0A18.121,18.121,0,0,0,7.621,37.761a21.637,21.637,0,1,1,35.246,0Z"
              transform="translate(0 -0.011)"
              stroke={!settings.darkmode ? "#fff" : "#000"}
              strokeWidth="1"
            />
          </svg>
          Spieler
        </h2>
      </header>
      <form
        className="players"
        style={{ color: !settings.darkmode ? "#fff" : "#000" }}
        onSubmit={(e) => {
          e.preventDefault();
          if (newPlayer.replaceAll(" ", "") !== "") {
            setSavedPlayers([...savedPlayers, newPlayer]);
            setNewPlayer("");
            history.push("/players");
          }
        }}
      >
        <h4>+ Neuen Spieler erstellen</h4>
        <InputOutput
          input
          title={`Name des Spielers`}
          align={"left"}
          width={"100%"}
          placeholder={"Name"}
          state={newPlayer}
          setState={setNewPlayer}
          key={"1"}
          darkmode={!settings.darkmode}
        />
        <div className="buttons-ctrl">
          <button type="submit" className="blue-btn save">
            Speichern
          </button>
          <button
            onClick={() => {
              setNewPlayer("");
              history.push("/players");
            }}
            className="red-btn cancel"
          >
            Abbrechen
          </button>
        </div>
      </form>
    </Card>
  );
};

const Card = styled.div`
  width: 100%;
  min-height: 100vh;
  min-width: 18rem;
  display: flex;
  flex-direction: column;
  padding-bottom: 5rem;
  padding: 0 15%;
  transition: padding 0.5s ease;
  @media (max-width: 50rem) {
    padding: 0;
    padding-bottom: 5rem;
  }
  .players {
    padding: 2rem 1rem 0 1rem;
    h4 {
      font-size: 1.3rem;
      white-space: nowrap;
      margin-bottom: 2rem;
    }
    .buttons-ctrl {
      width: 100%;
      .save {
        width: calc(70% - 0.5rem);
        margin-right: 0.5rem;
      }
      .cancel {
        width: calc(30% - 0.5rem);
        margin-left: 0.5rem;
      }
      @media (max-width: 30rem) {
        .save,
        .cancel {
          width: 100%;
          margin: 0.5rem 0;
        }
      }
    }
  }
  h2 {
    font-size: 1.4rem;
    display: flex;
    align-items: center;
    white-space: nowrap;
    svg {
      width: 2rem;
      height: 2rem;
      margin-right: 0.8rem;
    }
  }
  header {
    width: 100%;
    height: 5rem;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 1rem 0 1rem;
    button {
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      margin-left: 1rem;
    }
  }
`;

export default NewPlayer;
